import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectiDB,
  selectVersion,
  updateState,
  UpdateVersionByImport,
  selectVersionByImport,
} from "../../features/counter/counterSlice";
import { useNavigate } from "react-router-dom";
new Worker(new URL("../../workers/download.js", import.meta.url), { type: "module" });
import { AppHeader, AppLayout, AppSidebar } from "../Layout";
import useAuth from "../../hooks/useAuth";
import Loader from "../Loader/Loader";
import styles from "./ModernImportPage.module.scss";

const ModernImportPage = () => {
  const { isLogged, isLoading, authDetails } = useAuth();
  const navigate = useNavigate();

  const iDB = useSelector(selectiDB);
  const ccmsversion = useSelector(selectVersion);
  const [version, setVersion] = useState("");
  const versionByImport = useSelector(selectVersionByImport);
  const dispatch = useDispatch();

  const handleVersionChange = (e) => {
    const newValue = e.target.value;
    iDB.clear().then(() => {
      iDB.keys().then((keys) => {
        setVersion(newValue);
        // Save to sessionStorage for persistence across navigation
        sessionStorage.setItem("ccms_selected_version", newValue);
        dispatch(updateState({ version: { ...ccmsversion, selected: newValue } }));
        iDB.config({ name: newValue });
        dispatch(UpdateVersionByImport(true));

        window.location.href = "/";
      });
    });
  };
  useEffect(() => {
    console.log("Component mounted", authDetails.email, authDetails.institution);
  }, [authDetails]);

  const filteredUser =
    authDetails.email?.includes("@tg.org.au") &&
    (authDetails.institution === "Therapeutic Guidelines" ||
      authDetails.institution === "Therapeutic Guidelines Limited");

  useEffect(() => {
    !isLoading && !filteredUser && navigate("/");
  }, [isLogged, isLoading, filteredUser, navigate]);

  return isLogged && filteredUser ? (
    <AppLayout appSidebar={<AppSidebar />} appHeader={<AppHeader />} useMainContentWrapper={false}>
      <div className={`import-card-container size-16 regular ${styles.importContainer}`}>
        <div className="import-card">
          <h3 className={styles.title}>Select Content Slot</h3>
          <div className={`form-group ${styles.formGroup}`}>
            <label htmlFor="options">Change slot:</label>
            <select
              className="import-form-control"
              id="options"
              value={version}
              onChange={(e) => handleVersionChange(e)}
            >
              <option value="" disabled>
                Select a version
              </option>
              {ccmsversion.items.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            {versionByImport && (
              <p className={styles.successMessage}>
                Content has been successfully updated to {version}{" "}
              </p>
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  ) : isLoading ? (
    <Loader />
  ) : null;
};

export default ModernImportPage;
